import { Reveal } from "@/motion";
import { Section } from "@/components/Section";
import { InteractiveHoverButton } from "@/components/ui/interactive-hover-button";

export function CallToAction() {
  return (
    <Section labelledBy="cta-title">
      <Reveal as="div" className="cta" distance={32}>
        <h2 id="cta-title" className="cta__title">
          Trust your path.
        </h2>
        <p className="cta__lede">Start with the tee everything else is built around.</p>
        <InteractiveHoverButton
          onClick={() => {
            document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });
          }}
        >
          Shop the range
        </InteractiveHoverButton>
      </Reveal>
    </Section>
  );
}
